import { createApp } from "vue";
import "./css/style.css";
import App from "./App.vue";
import { install } from "vue3-recaptcha-v2";

import { recaptcha_v2_site_key } from "./constants/envrionment";
import svgSprite from '../../../../resources/vue_apps/shared_components/svgSprite.js';
let app = createApp(App).use(svgSprite);

app.use(install, {
    sitekey: recaptcha_v2_site_key,
    cnDomains: false, // Optional, If you use in China, set this value true
})
app.mount("#quoteHolder");